// extracted by mini-css-extract-plugin
export default {"latest-post":"LatestPost_latest-post__0yEQu","image":"LatestPost_image__2pUiG","title":"LatestPost_title__6MdLG","link":"LatestPost_link__O6Kxy","date":"LatestPost_date__Kl-kk"};